<template>
  <div>
    <div class="wrapper">
      <div class="section">
        <img src="../../../assets/dashboard/icon-alert1.png" alt />
        <div class="list">
          <div class="item">
            <div class="value">{{ sewageLength }}km</div>
            <div class="label">污水管道</div>
          </div>
        </div>
      </div>
      <div class="section">
        <img src="../../../assets/dashboard/icon-alert2.png" alt />
        <div class="list">
          <div class="item">
            <div class="value">{{ rainLength }}km</div>
            <div class="label">雨水管道</div>
          </div>
        </div>
      </div>
    </div>

    <div class="wrapper" style="gap: 0">
      <div class="chart" style="height: 17vh; flex: 1" id="sewage"></div>
      <div class="chart" style="height: 17vh; flex: 1" id="rain"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts/core";
import { TooltipComponent } from "echarts/components";
import { PieChart } from "echarts/charts";
import { LabelLayout } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([TooltipComponent, PieChart, CanvasRenderer, LabelLayout]);

export default {
  props: {
    sewageLength: {
      type: Number,
      default: 0,
    },
    rainLength: {
      type: Number,
      default: 0,
    },

    sewageLengthList: {
      type: Array,
      default: () => [],
    },

    rainLengthList: {
      type: Array,
      default: () => [],
    },
  },

  beforeDestroy() {
    this.sewageChart?.dispose();
    this.rainChart?.dispose();
  },

  watch: {
    sewageLengthList: {
      handler() {
        if (this.sewageLengthList.length > 0) {
          this.initSewageChart();
        }
      },
      deep: true,
    },
    rainLengthList: {
      handler() {
        if (this.rainLengthList.length > 0) {
          this.initRainChart();
        }
      },
      deep: true,
    },
  },

  methods: {
    initSewageChart() {
      var chartDom = document.getElementById("sewage");
      this.sewageChart = echarts.init(chartDom);
      var option;
      option = {
          color: ['#6552D5', '#70D9DA', '#54A8BF', '#3180C0', '#3067C0'],
          tooltip: {
            trigger: "item",
          },
          series: [
              {
                  radius: ['32%', '50%'],
                  center: ['50%', '45%'],
                  type: 'pie',
                  label: {
                      show: true,
                      formatter: ["{title|{b}}", "{percentage|{d}%}"].join("\n"),
                      rich: {
                        title: {
                          lineHeight: 18,
                          color: '#fff',
                          borderWidth: 0,
                          backgroundColor: 'transparent',
                        },
                        percentage: {
                          fontSize: 12,
                          color: '#fff',
                        },
                      },
                    },
                  labelLine: {
                    show: true,
                    color: "#fff",
                  },
                  emphasis: {
                      disabled: true
                  },
                  name: "",
                  data: this.sewageLengthList,
              },
              {
                  radius: ['30%', '31%'],
                  center: ['50%', '45%'], // 内圈位置同步下移
                  silent: true,
                  type: 'pie',
                  label: { show: false },
                  labelLine: { show: false },
                  animation: false,
                  tooltip: {
                      show: false
                  },
                  data: [{
                      value: 1,
                      itemStyle: {
                          color: "rgba(250,250,250,0.3)",
                      },
                  }],
              }, {
                  name: '外边框',
                  type: 'pie',
                  clockwise: true,
                  center: ['50%', '45%'], // 外边框位置同步下移
                  radius: ['53%', '53%'],
                  label: { show: false },
                  data: [{
                      value: 9,
                      name: '',
                      itemStyle: {
                          borderWidth: 2,
                          borderColor: '#0b5263'
                      }
                  }]
              }
          ]
      };
      option && this.sewageChart.setOption(option);
    },

    initRainChart() {
      var chartDom = document.getElementById("rain");
      this.rainChart = echarts.init(chartDom);
      var option;
        option = {
            color: ['#54A8BF', '#3180C0', '#3067C0'],
            tooltip: {
                trigger: "item",
            },
            series: [
                {
                    radius: ['32%', '50%'],
                    center: ['50%', '45%'],
                    type: 'pie',
                    label: {
                        show: true,
                        formatter: ["{title|{b}}", "{percentage|{d}%}"].join("\n"),
                        rich: {
                            title: {
                                lineHeight: 18,
                                color: '#fff',
                                borderWidth: 0,
                                backgroundColor: 'transparent',
                            },
                            percentage: {
                                fontSize: 12,
                                color: '#fff',
                            },
                        },
                    },
                    labelLine: {
                        show: true,
                        color: "#fff",
                    },
                    emphasis: {
                        disabled: true
                    },
                    name: "",
                    data: this.rainLengthList,
                },
                {
                    radius: ['30%', '31%'],
                    center: ['50%', '45%'], // 内圈位置同步下移
                    silent: true,
                    type: 'pie',
                    label: { show: false },
                    labelLine: { show: false },
                    animation: false,
                    tooltip: {
                        show: false
                    },
                    data: [{
                        value: 1,
                        itemStyle: {
                            color: "rgba(250,250,250,0.3)",
                        },
                    }],
                }, {
                    name: '外边框',
                    type: 'pie',
                    clockwise: true,
                    center: ['50%', '45%'], // 外边框位置同步下移
                    radius: ['53%', '53%'],
                    label: { show: false },
                    data: [{
                        value: 9,
                        name: '',
                        itemStyle: {
                            borderWidth: 2,
                            borderColor: '#0b5263'
                        }
                    }]
                }
            ]
        };
      // option = {
      //   color: ["#FFA700", "#3AA1FF"],
      //   tooltip: {
      //     trigger: "item",
      //   },
      //   series: [
      //     {
      //       name: "",
      //       type: "pie",
      //       radius: "40%",
      //       avoidLabelOverlap: false,
      //       label: {
      //         show: true,
      //         formatter: ["{title|{b}}", "{percentage|{d}%}"].join("\n"),
      //         rich: {
      //           title: {
      //             lineHeight: 18,
      //           },
      //           percentage: {
      //             fontSize: 12,
      //             fontWeight: "bold",
      //           },
      //         },
      //       },
      //       labelLine: {
      //         show: true,
      //       },
      //       data: this.rainLengthList,
      //       // data: [
      //       //   { value: info.thinLength, name: "主管" },
      //       //   { value: info.thickLength, name: "支管" },
      //       // ],
      //     },
      //   ],
      // };

      option && this.rainChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  display: flex;
  gap: 1vw;

  .section {
    flex: 1;
    position: relative;
    display: flex;
    align-items: center;

    &::after {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      width: 2px;
      background: linear-gradient(
        180deg,
        rgba(103, 146, 127, 0) 0%,
        #67927f 53%,
        rgba(103, 146, 127, 0) 100%
      );
    }

    &:last-child::after {
      background: transparent;
    }

    img {
      height: 4vh;
    }
    .list {
      flex: 1;
      display: flex;
      justify-content: space-around;
      .item {
        text-align: center;
        .value {
          font-size: 2vh;
          font-weight: bold;
          color: #299bc5;
          margin-bottom: 0.2vh;
        }
        .label {
          font-size: 1.8vh;
          font-weight: bold;
          color: rgba(255, 255, 255, 0.75);
        }
      }
    }
  }
}
</style>